import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import SearchBar from './SearchBar';
import UserMenu from './UserMenu';
import './Navbar.css';

const Navbar = () => {
    const navigate = useNavigate();
    const [user] = useAuthState(auth);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleSignOut = async () => {
        try {
            await auth.signOut();
            navigate('/');
        } catch (error) {
            console.error('Sign out error:', error);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <Link to="/" className="logo">
                    <img src="https://aysaorganizasyon.com/wp-content/uploads/2022/12/Aysa-Logo.png" alt="AYSA" />
                </Link>
            </div>

            <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
            </button>

            <div className={`navbar-content ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="search-container">
                    <SearchBar />
                </div>

                <div className="navbar-right">
                    <UserMenu user={user} onSignOut={handleSignOut} />
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
